import React from "react";
import { Route, Routes } from "react-router-dom";
// import { OrderDetails } from "./details/";
import { UsersList } from "./list";
import { UsersContextProvider } from "./context";
import { UserInfo } from "./details";

const UsersModule = () => {
  return (
    // The provider wraps the list route only: mounted above the details route
    // it would keep fetching (and resetting the URL page) while details are open.
    <Routes>
      <Route
        index
        element={
          <UsersContextProvider syncWithUrl>
            <UsersList />
          </UsersContextProvider>
        }
      />
      <Route path="details/:userId" element={<UserInfo />} />
    </Routes>
  );
};

export default UsersModule;
